import { getSummaryReportTopologyMock } from "stores/slice/bogus/summaryReport/topology";
import { getSummaryReportClientsMock } from "stores/slice/bogus/summaryReport/clients";
import { getSummaryReportDevicesMock } from "stores/slice/bogus/summaryReport/devices";

const summaryReportConfig = {
  "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/exports.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/exports",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/exports.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/exports",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
  },
  "/orgs/:orgId/sites/:siteId/summaryReports.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/summaryReports",
    restful: true,
    method: "read",
    mockSelector: "summaryReportList",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports",
    restful: true,
    method: "read",
    mockSelector: "summaryReportList",
  },
  "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/logs.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/logs",
    restful: true,
    method: "read",
    mockSelector: "summaryReportLogs",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/logs.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/logs",
    restful: true,
    method: "read",
    mockSelector: "summaryReportLogs",
  },
  "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/topology.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/topology",
    restful: true,
    method: "read",
    mockSelector: "summaryReportTopology",
    mockHandler: ({ state, restfulPlaceholders }) =>
      getSummaryReportTopologyMock({
        summaryReportId: restfulPlaceholders.summaryReportId,
        reports: state.summaryReportList?.data?.items,
      }),
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/topology.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/topology",
    restful: true,
    method: "read",
    mockSelector: "summaryReportTopology",
    mockHandler: ({ state, restfulPlaceholders }) =>
      getSummaryReportTopologyMock({
        summaryReportId: restfulPlaceholders.summaryReportId,
        reports: state.summaryReportList?.data?.items,
      }),
  },
  "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/aiInsight.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/aiInsight",
    restful: true,
    method: "read",
    mockSelector: "summaryReportAInsight",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/aiInsight.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/aiInsight",
    restful: true,
    method: "read",
    mockSelector: "summaryReportAInsight",
  },
  "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/devices.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/devices",
    restful: true,
    method: "read",
    mockSelector: "summaryReportDevices",
    mockHandler: ({ restfulPlaceholders }) =>
      getSummaryReportDevicesMock({
        summaryReportId: restfulPlaceholders.summaryReportId,
      }),
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/devices.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/devices",
    restful: true,
    method: "read",
    mockSelector: "summaryReportDevices",
    mockHandler: ({ restfulPlaceholders }) =>
      getSummaryReportDevicesMock({
        summaryReportId: restfulPlaceholders.summaryReportId,
      }),
  },
  "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/overview.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/overview",
    restful: true,
    method: "read",
    mockSelector: "summaryReportOverview",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/overview.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/overview",
    restful: true,
    method: "read",
    mockSelector: "summaryReportOverview",
  },
  "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/clients.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/clients",
    restful: true,
    method: "read",
    mockSelector: "summaryReportClients",
    mockHandler: ({ restfulPlaceholders }) =>
      getSummaryReportClientsMock({
        summaryReportId: restfulPlaceholders.summaryReportId,
      }),
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/clients.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/clients",
    restful: true,
    method: "read",
    mockSelector: "summaryReportClients",
    mockHandler: ({ restfulPlaceholders }) =>
      getSummaryReportClientsMock({
        summaryReportId: restfulPlaceholders.summaryReportId,
      }),
  },
  "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/wirelessInsight.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/wirelessInsight",
    restful: true,
    method: "read",
    mockSelector: "summaryReportWirelessInsight",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/wirelessInsight.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/wirelessInsight",
    restful: true,
    method: "read",
    mockSelector: "summaryReportWirelessInsight",
  },
  "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/wiredInsight.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/wiredInsight",
    restful: true,
    method: "read",
    mockSelector: "summaryReportWiredInsight",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/wiredInsight.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/wiredInsight",
    restful: true,
    method: "read",
    mockSelector: "summaryReportWiredInsight",
  },
};

export default summaryReportConfig;
